const DescriptionRatings = {
  THUMBS_DOWN: 'THUMBS_DOWN',
  THUMBS_UP: 'THUMBS_UP'
};
export default DescriptionRatings;